const indexItems = [
  { title: '古装权谋剧', count: '128部', desc: '宫斗智谋、历史风云' },
  { title: '悬疑推理剧', count: '96部', desc: '烧脑破案、层层反转' },
  { title: '都市爱情剧', count: '215部', desc: '甜蜜浪漫、温暖治愈' },
  { title: '职场励志剧', count: '83部', desc: '奋斗成长、打工人共鸣' },
  { title: '韩剧专区', count: '312部', desc: '浪漫温情、精品制作' },
  { title: '年代史诗剧', count: '67部', desc: '家国情怀、岁月沉淀' },
  { title: '奇幻冒险剧', count: '74部', desc: '架空世界、想象力全开' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            剧集索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按题材快速找到你喜欢的电视剧类型，总有一类适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.slice(0, 4).map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <h3 className="text-sm font-heading font-semibold text-foreground-800 mb-1 group-hover:text-accent-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-3">{item.desc}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-accent-500 bg-accent-50 px-2 py-0.5 rounded">{item.count}</span>
                <span className="w-5 h-5 flex items-center justify-center text-foreground-300 group-hover:text-accent-500 transition-colors">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {indexItems.slice(4).map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <h3 className="text-sm font-heading font-semibold text-foreground-800 mb-1 group-hover:text-accent-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-3">{item.desc}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-accent-500 bg-accent-50 px-2 py-0.5 rounded">{item.count}</span>
                <span className="w-5 h-5 flex items-center justify-center text-foreground-300 group-hover:text-accent-500 transition-colors">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}